import { render, staticRenderFns } from "./CompanyContactCard.vue?vue&type=template&id=dce1b744&scoped=true&"
import script from "./CompanyContactCard.vue?vue&type=script&lang=js&"
export * from "./CompanyContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce1b744",
  null
  
)

export default component.exports